import { render, staticRenderFns } from "./NotificationClinicianDetails.vue?vue&type=template&id=5fb2a30f&"
import script from "./NotificationClinicianDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationClinicianDetails.vue?vue&type=script&lang=js&"
import style0 from "./NotificationClinicianDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NotificationClinicianDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports